import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { LicensesComponent } from './pages/licenses/licenses.component';
import { AboutComponent } from './pages/about/about.component';
import { TeamComponent } from './pages/team/team.component';
import { FaqComponent } from './pages/faq/faq.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AuthComponent } from './pages/auth/auth.component';
import { QuicktransferComponent } from './pages/quicktransfer/quicktransfer.component';
import { MmtComponent } from './pages/mmt/mmt.component';
import { RewardsCalculatorComponent } from './pages/rewards-calculator/rewards-calculator.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { EducationComponent } from './pages/education/education.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CurrencyFilterPipe } from './pipes/currency-filter.pipe';
import { FormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { ExCalcComponent } from './component/ex-calc/ex-calc.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { HowItWorksComponent } from './component/how-it-works/how-it-works.component';
import { WhySingxComponent } from './component/why-singx/why-singx.component';
import { CountryCoverageComponent } from './component/country-coverage/country-coverage.component';
import { CountryService } from './country.service';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { BankDetailsComponent } from './pages/quicktransfer/quicktransfer-bankdetails/bankdetails.component';

import { FinancialservicesComponent } from './pages/financialservices/financialservices.component';
import { ProductdisclosureComponent } from './pages/productdisclosure/productdisclosure.component';

import { HomeRoutingComponent } from './pages/home-routing/home-routing.component';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form'; // Import NzFormModule
import { NzInputModule } from 'ng-zorro-antd/input'; // Import NzInputModule
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';




@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        ContactComponent,
        HomeComponent,
        HomeRoutingComponent,
        LicensesComponent,
        AboutComponent,
        TeamComponent,
        FaqComponent,
        PrivacyPolicyComponent,
        AuthComponent,
        TermsOfUseComponent,
        EducationComponent,
        WalletComponent,
        CurrencyFilterPipe,
        ExCalcComponent,
        HowItWorksComponent,
        WhySingxComponent,
        CountryCoverageComponent,
        QuicktransferComponent,
        MmtComponent,
        RewardsCalculatorComponent,
        FinancialservicesComponent,
        ProductdisclosureComponent,
        BankDetailsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule.withServerTransition({ appId: 'serverApp' }),
        RouterModule.forRoot([
            { path: '', component: HomeComponent },
            { path: 'au', component: HomeRoutingComponent },
            { path: 'sg', component: HomeRoutingComponent },
            { path: 'hk', component: HomeRoutingComponent },
            { path: 'contact-us', component: ContactComponent },
            { path: 'licenses', component: LicensesComponent },
            { path: 'aboutus', component: AboutComponent },
            { path: 'team', component: TeamComponent },
            { path: 'faq', component: FaqComponent },
            { path: 'privacy-policy', component: PrivacyPolicyComponent },
            { path: 'authorisation', component: AuthComponent },
            { path: 'terms-of-use', component: TermsOfUseComponent },
            { path: 'education', component: EducationComponent },
            { path: 'wallet', component: WalletComponent },
            { path: 'quicktransfer', component: QuicktransferComponent },
            { path: 'makemytrip-discount', component: MmtComponent },
            { path: 'rewards-calculator', component:  RewardsCalculatorComponent},
            { path: 'country-details', component: QuicktransferComponent },
            { path: 'financialservices', component: FinancialservicesComponent },
            { path: 'productdisclosure', component: ProductdisclosureComponent },
            { path: '**', redirectTo: "/" },
        ]),
        FormsModule,
        NzToolTipModule,
        NzPopoverModule,
        BrowserAnimationsModule,
        NzDrawerModule,
        NzMenuModule,
        NzModalModule,
        NzNotificationModule,
        NzRadioModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzFormModule, // Add this line
        NzInputModule, // Add this line
        NzGridModule,
        NzEmptyModule,
        NzSpinModule,
        NzCollapseModule], providers: [
        { provide: NZ_I18N, useValue: en_US },
        CountryService,
        provideClientHydration(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
